import type { Ui } from '@tectonics/prs/ui';

export const getDisablePhoneNumberPrefillPaymentTypes = (ui: Ui): readonly string[] => {
  const paymentTypes = ui.disable_phone_number_prefill_payment_types;
  return Array.isArray(paymentTypes) ? paymentTypes : [];
};

export const shouldDisablePhoneNumberPrefill = (ui: Ui, paymentTypeCode: string): boolean =>
  paymentTypeCode !== '' && getDisablePhoneNumberPrefillPaymentTypes(ui).includes(paymentTypeCode);
